export default __webpack_public_path__ + "static/media/light.462ca6a5.png";